/**
 * How a hub route says "this body came from the mirror, not the hub".
 *
 * `HubReadEnvelope` already carries that for routes shaped around it, and the
 * base query records it into the hub-status slice. But several hub routes
 * return the hub's raw shape because their callers consume it directly —
 * guide lineups, video configs — and those had no way to say the same thing.
 *
 * That gap was not cosmetic. A hub can answer some endpoints and fail others
 * (S6702 returns 200 on /video/mediaPlayers and 500 on /video/configs), so the
 * probe reports it healthy while the route quietly serves cached values. The
 * page then renders them as live and its Save writes them BACK to the hub —
 * turning a read fallback into a data-loss path. A header on the response
 * closes it: the client marks the hub stale exactly when a body is cached,
 * whatever the probe thinks, and every mutation gate keys off that.
 */

/** Present and set to `postgres-fallback` when the body came from the mirror. */
export const HUB_SOURCE_HEADER = 'x-atlas-hub-source'

/** ISO timestamp the mirrored body was last synced, when known. */
export const HUB_SYNCED_AT_HEADER = 'x-atlas-hub-synced-at'

export const HUB_SOURCE_FALLBACK = 'postgres-fallback'

/** Headers marking a response as mirror-served. */
export function hubMirrorHeaders(staleAt?: string | null): HeadersInit {
  return staleAt
    ? {
        [HUB_SOURCE_HEADER]: HUB_SOURCE_FALLBACK,
        [HUB_SYNCED_AT_HEADER]: staleAt
      }
    : { [HUB_SOURCE_HEADER]: HUB_SOURCE_FALLBACK }
}
